var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0834 3.66667H3.66671C3.18048 3.66667 2.71416 3.85982 2.37034 4.20364C2.02653 4.54745 1.83337 5.01377 1.83337 5.5V18.3333C1.83337 18.8196 2.02653 19.2859 2.37034 19.6297C2.71416 19.9735 3.18048 20.1667 3.66671 20.1667H16.5C16.9863 20.1667 17.4526 19.9735 17.7964 19.6297C18.1402 19.2859 18.3334 18.8196 18.3334 18.3333V11.9167M16.9584 2.29167C17.323 1.92699 17.8176 1.72212 18.3334 1.72212C18.8491 1.72212 19.3437 1.92699 19.7084 2.29167C20.073 2.65634 20.2779 3.15094 20.2779 3.66667C20.2779 4.18239 20.073 4.67699 19.7084 5.04167L11 13.75L7.33337 14.6667L8.25004 11L16.9584 2.29167Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTou);
export default __webpack_public_path__ + "static/media/icon-tou.e929d4c3bf43a2e544401c84aa624c72.svg";
export { ForwardRef as ReactComponent };